import "@animech/platform/polyfills/autorun";
import "@animech/platform/extensions/autorun";
import { Bootstrapper } from "core/bootstrapper";
new Bootstrapper().start();
